import { render, staticRenderFns } from "./RichText.vue?vue&type=template&id=72784c80&scoped=true"
import script from "./RichText.vue?vue&type=script&lang=js"
export * from "./RichText.vue?vue&type=script&lang=js"
import style0 from "./RichText.vue?vue&type=style&index=0&id=72784c80&prod&lang=less&scoped=true"
import style1 from "./RichText.vue?vue&type=style&index=1&id=72784c80&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72784c80",
  null
  
)

export default component.exports